import ICampaignID from '../../types/ICampaignID';
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";
import Options from '../../types/Options';

// Class to work with cookie as a campaing UUID container
export default class CampaignInfoInjectionContainer implements ICampaignInfoContainer {
  readonly containerName = 'injection';
  readonly parameterName = 'campaignUuid';
  private campaignUuid: string;

  constructor(options: Options) {
    this.campaignUuid = options[this.parameterName];
  }

  load() {
    const result: ICampaignID = {
      UUID: this.campaignUuid,
      container: this.containerName
    };

    return result.UUID ? result : null;
  }

  store (campaignId: ICampaignID) {

    return !!this.campaignUuid;
  }
}